import { Avatar, Dropdown, Navbar } from "flowbite-react";
import unologo from "../../img/UNO_logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useState } from "react";
import toast from "react-hot-toast";
import FullscreenLoader from "../../components/sub-components/FullscreenLoader";

export default function AdminDashboardHeader() {
  const { user, setUser } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    setIsLoading(true);
    sessionStorage.removeItem("user");
    setUser(null);

    setTimeout(() => {
      navigate("/login");
      toast.success("Logout Success");
    }, 3000);
  };

  if (isLoading) {
    return (
      <>
        <FullscreenLoader isLoading={isLoading} />
      </>
    );
  }

  return (
    <Navbar fluid className="bg-[#111a39] dark:bg-[#111a39] text-white">
      <Navbar.Brand href="https://flowbite-react.com">
        <img src={unologo} className="mr-3 h-6 sm:h-9" alt="Uno" />
        <span className="font-bold text-3xl">UNO</span>
      </Navbar.Brand>
      <div className="flex md:order-2 bg-[#111a39]">
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar
              alt="User settings"
              img="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
              rounded
            />
          }
          className="bg-[#122a39] text-white border-none shadow-md hover:bg-[#1a3b58] hover:shadow-lg transition-all duration-300 font-extrabold text-md"
        >
          <Dropdown.Header>
            <span className="block text-[#fff] cursor">{user?.fullName}</span>
            <span className="text-[#fff]">{user?.email}</span>
          </Dropdown.Header>
          <Link to={"/admin-dashboard"}>
            <Dropdown.Item className="text-[#fff] hover:bg-white hover:text-[#111a39] transition-all duration-300">
              Dashboard
            </Dropdown.Item>
          </Link>
        <Link to={"/admin-queries-management"}>
            <Dropdown.Item className="text-[#fff] hover:bg-white hover:text-[#111a39] transition-all duration-300">
              Queries Management
            </Dropdown.Item>
          </Link>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={logout}
            className="text-[#fff] hover:bg-white hover:text-[#111a39] transition-all duration-300"
          >
            {isLoading ? "Logging out..." : "LogOut"}
          </Dropdown.Item>
        </Dropdown>
      </div>
      {/* Loader component rendered separately */}

      <Navbar.Collapse>
        <Navbar.Link
          href="/admin-dashboard"
          className="text-[#fff] cursor-pointer font-bold text-lg"
        >
          Dashboard
        </Navbar.Link>
        <Navbar.Link
          href="/admin-queries-management"
          className="text-[#fff] cursor-pointer font-bold text-lg"
        >
          Queries Management
        </Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
}
